import { Fragment, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";
import API_BASE_URL from "../../config/api";
import "./ContactForm.css";

const countryCodes = [
  { code: "+234", label: "🇳🇬 Nigeria (+234)" },
  { code: "+1", label: "🇺🇸 United States (+1)" },
  { code: "+1", label: "🇨🇦 Canada (+1)" },
  { code: "+44", label: "🇬🇧 United Kingdom (+44)" },
  { code: "+91", label: "🇮🇳 India (+91)" },
  { code: "+233", label: "🇬🇭 Ghana (+233)" },
  { code: "+254", label: "🇰🇪 Kenya (+254)" },
  { code: "+27", label: "🇿🇦 South Africa (+27)" },
  { code: "+971", label: "🇦🇪 UAE (+971)" },
  { code: "+49", label: "🇩🇪 Germany (+49)" },
  { code: "+33", label: "🇫🇷 France (+33)" },
  { code: "+61", label: "🇦🇺 Australia (+61)" },
  { code: "+55", label: "🇧🇷 Brazil (+55)" },
  { code: "+81", label: "🇯🇵 Japan (+81)" },
  { code: "+86", label: "🇨🇳 China (+86)" },
  { code: "+34", label: "🇪🇸 Spain (+34)" },
  { code: "+39", label: "🇮🇹 Italy (+39)" },
  { code: "", label: "🌐 Other (Type Code)" },
];

function ContactForm() {
  const [topic, setTopic] = useState("Payment");
  const [product, setProduct] = useState("SoloChat Messenger");
  const [email, setEmail] = useState("");
  const [countryCode, setCountryCode] = useState("+234");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [description, setDescription] = useState("");

  const [show, setShow] = useState(false);
  const [sentStatus, setSentStatus] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleClose = () => setShow(false);

  useEffect(() => {
    const hash = window.location.hash.replace("#", "").toLowerCase();
    const map = {
      brom: "Brom - Watch Parties Together",
      findme: "FindMe App",
      formscanx: "FormScanX - AI Document Scanner",
    };
    if (map[hash]) setProduct(map[hash]);
  }, []);

  const needsPhone = product === "SoloChat Messenger" || product === "FindMe App";
  const phoneRequired = product === "SoloChat Messenger";

  const handleSubmit = async (e) => {
    e.preventDefault();

    let fullPhone = phoneNumber.trim();
    if (fullPhone) {
      if (!fullPhone.startsWith("+") && countryCode) {
        fullPhone = `${countryCode} ${fullPhone}`;
      }
    }

    if (phoneRequired && !fullPhone) {
      alert("Phone number is required for SoloChat Messenger");
      return;
    }

    if (product === "FindMe App" && !email.trim() && !fullPhone) {
      alert("Please provide either an email or phone number");
      return;
    }

    setSubmitting(true);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/v1/contact`,
        {
          email: email.trim(),
          phone: fullPhone,
          body: description.trim(),
          topic,
          product,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setSentStatus(true);
        setShow(true);
        setEmail("");
        setPhoneNumber("");
        setDescription("");
      }
    } catch (error) {
      console.error(error.message);
      setSentStatus(false);
      setShow(true);
    }
    setSubmitting(false);
  };

  return (
    <Fragment>
      <div className="contactForm">
        <form className="contactFormInner" onSubmit={handleSubmit}>
          <div className="contactField">
            <label htmlFor="product">Product</label>
            <select id="product" value={product} onChange={(e) => setProduct(e.target.value)}>
              <option value="SoloChat Messenger">SoloChat Messenger</option>
              <option value="FindMe App">FindMe App</option>
              <option value="FormScanX - AI Document Scanner">FormScanX - AI Document Scanner</option>
              <option value="Brom - Watch Parties Together">Brom - Watch Parties Together</option>
            </select>
          </div>

          <div className="contactField">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              name="email"
              id="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          {needsPhone && (
            <div className="contactField">
              <label htmlFor="number">
                Phone Number {phoneRequired ? "(required)" : "(optional)"}
              </label>
              <div className="phoneInputGroup">
                <select
                  className="countryCodeSelect"
                  value={countryCode}
                  onChange={(e) => setCountryCode(e.target.value)}
                  aria-label="Country Code"
                >
                  {countryCodes.map((item, idx) => (
                    <option key={idx} value={item.code}>
                      {item.label}
                    </option>
                  ))}
                </select>
                <input
                  className="phoneInputField"
                  required={phoneRequired}
                  type="tel"
                  inputMode="tel"
                  autoComplete="tel"
                  name="number"
                  id="number"
                  placeholder={countryCode ? "e.g. 801 234 5678" : "+1 555 123 4567"}
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
              </div>
            </div>
          )}

          <div className="contactField">
            <label htmlFor="topic">Topic</label>
            <select id="topic" value={topic} onChange={(e) => setTopic(e.target.value)}>
              <option value="Payment">Payment</option>
              <option value="Features">Features</option>
              <option value="Errors">Errors</option>
              <option value="Others">Others</option>
            </select>
          </div>

          <div className="contactField">
            <label htmlFor="description">Description</label>
            <textarea
              required
              name="description"
              id="description"
              rows="6"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Tell us how we can help..."
            />
          </div>
          <div className="contactFormAction">
            <button className="contactSubmit" type="submit" disabled={submitting}>
              {submitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {sentStatus ? "Sent Successfully" : "Oops!"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {sentStatus
            ? "Thank You for contacting us, we'll reply you as soon as possible"
            : "Unsuccessful, Please try again"}
        </Modal.Body>
        <Modal.Footer>
          <Button className="modalBtn" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
}

export default ContactForm;

